export default {"src":"/_next/static/media/uploadImage.f2ce335b.svg","height":650,"width":650};